<template>
    <div class="table_wrap">
        <div class="table_search row has_bc">
            <el-row>
                <el-col :span="12" >
                </el-col>
                <el-col :span="12" class="text_right">
                </el-col>
            </el-row>
        </div>

        <el-table
            :data="elasticData"
            style="width: 100%"
            empty-text="데이터가 없습니다."
            @selection-change="tableSelectChange"

        >
            <el-table-column
                class="table_no"
                type="index"
                label="No"
                width="80"
                class-name="num text-center"
                :index="tableIdx"
            >
            </el-table-column>
            <el-table-column label="게시번호" width="150" prop="wr_id" class-name="text-center"></el-table-column>
            <el-table-column label="제목" prop="wr_subject" class-name="text-center"></el-table-column>
            <el-table-column
                label="작성일" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnDateUnix(scope.row.created_at)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                label="옵션" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <div>
                        <el-button
                            size="mini"
                            type="warning"
                            @click="goDetail(scope.row.wr_id)"
                        >
                            상세
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import util from "@/mixins/util";
import {loginType} from "@/service/MemberService";
import dateMixins from "@/mixins/dateMixins";

export default {
    name: "ElasticListCafePostLayout",
    mixins: [dateMixins],
    components: {
    },
    provide() {
        return {}
    },
    inject: ['elasticListSetData'],
    props: {
        elasticData: {
            type: Array,
            default: () => {return []}
        },
        paginationData: {default: {page: 1, size: 10, total: 0}},
    },
    data() {
        return {}
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        goDetail(no) {
            let nowPath = this.$route.path;
            this.$router.push(`/jst/board/post/${no}`);
        },
        tableIdx(index) {
            return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
        },
        tableSelectChange(row) {
            this.selectArr = row;
            this.elasticListSetData('selectArr', this.selectArr)
        },
        returnDate(date=null) {
            if(!date) {
                return '';
            }
            return this.$moment(date).format('YYYY-MM-DD HH:mm')
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
